
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ways-to-pay",
      function () {
        return require("private-next-pages/ways-to-pay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ways-to-pay"])
      });
    }
  